import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { Routes, provideRouter } from '@angular/router';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideToastr } from 'ngx-toastr';

import { dashGuard, guestGuard, trainingGuard } from './security.guard';
import { Index } from './components/pages';
import { LoginComponent } from './components/pages/login';
import { RegisterComponent } from './components/pages/register';
import { VerifyComponent } from './components/pages/verify';
import { SetupComponent } from './components/pages/setup';
import { DashboardComponent } from './components/pages/dashboard';
import { CarbonComponent } from './components/pages/dashboard/carbon';
import { EmissionComponent } from './components/pages/dashboard/emission';
import { ProfileComponent } from './components/pages/dashboard/profile';
import { TrainingComponent } from './components/pages/dashboard/training';
import { CompanyComponent } from './components/pages/dashboard/company';
import { CalculationsComponent } from './components/pages/dashboard/calculations';
import { ForgotComponent } from './components/pages/forgot';
import { ConfirmComponent } from './components/pages/confirm';
import { ResetComponent } from './components/pages/reset';
import { CalculationComponent } from './components/pages/calculation';
import { provideHttpClient } from '@angular/common/http';
import { GenerateReportComponent } from './components/pages/calculation/generate-report/generate-report.component';
import { InviteComponent } from './components/pages/invite';
import { PausedComponent } from './components/pages/paused';
import { environment } from '../environments/environment';

export const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: 'login' },
  {
    path: '',
    component: Index,
    canActivate: [guestGuard],
    children: [
      { path: 'login', component: LoginComponent },
      { path: 'register', component: RegisterComponent },
      { path: 'verify', component: VerifyComponent },
      { path: 'setup', component: SetupComponent },
      { path: 'forgot', component: ForgotComponent },
      { path: 'confirm', component: ConfirmComponent },
      { path: 'reset', component: ResetComponent }
    ]
  },
  { path: 'dashboard', pathMatch: 'full', redirectTo: 'dashboard/carbon' },
  {
    path: 'dashboard',
    component: DashboardComponent,
    canActivate: [dashGuard],
    children: [
      { path: 'carbon', component: CarbonComponent },
      { path: 'emission', component: EmissionComponent },
      {
        path: 'training',
        component: TrainingComponent,
        canActivate: [trainingGuard]
      },
      { path: 'profile', component: ProfileComponent },
      { path: 'company', component: CompanyComponent },
      { path: 'calculations', component: CalculationsComponent }
    ]
  },
  {
    path: 'calculation',
    canActivate: [dashGuard],
    component: CalculationComponent,
    children: [
      {
        path: 'generate-report',
        component: GenerateReportComponent
      }
    ]
  },
  {
    path: 'invite/:token',
    component: InviteComponent
  },
  { path: '**', redirectTo: 'login' }
];

const pausedRoutes: Routes = [{ path: '**', component: PausedComponent }];

export const appConfig: ApplicationConfig = {
  providers: [
    provideToastr({
      timeOut: 4000,
      positionClass: 'toast-top-right',
      preventDuplicates: true,
      progressBar: true,
      progressAnimation: 'decreasing',
      closeButton: true,
      toastClass: 'ngx-toastr custom-toast',
      titleClass: 'toast-title',
      messageClass: 'toast-message'
    }),
    provideHttpClient(),
    provideAnimations(),
    provideRouter(environment.servicePaused ? pausedRoutes : routes),
    provideZoneChangeDetection({ eventCoalescing: true })
  ]
};
